import { render, staticRenderFns } from "./BlogBoard.vue?vue&type=template&id=2d8e00f5&scoped=true"
import script from "./BlogBoard.vue?vue&type=script&lang=ts"
export * from "./BlogBoard.vue?vue&type=script&lang=ts"
import style0 from "./BlogBoard.vue?vue&type=style&index=0&id=2d8e00f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e00f5",
  null
  
)

export default component.exports